const styles = {
    sidebarContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // Adjusted to space-between to separate top content and logout button
        padding: '20px',
        width: '250px',
        height: 'calc(100vh - 43px)',
        maxWidth: '200px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        gap: 10
    },
    logoContainer: {
        textAlign: 'center',
    },
    activeMenuItem: {
        gap: '10px',
        backgroundColor: '#5958e1',
        borderRadius: 'var(--2, 16px)',
        color: 'white',
        fontWeight: 600,
        padding: '10px 16px',
        boxShadow: '0px 20px 50px 0px rgba(55, 69, 87, 0.10)',
        '&:hover': {
            backgroundColor: '#5958c0',
        },
    },
    inactiveMenuItem: {
        gap: '10px',
        color: '#737791',
        borderRadius: 'var(--2, 16px)',
        fontWeight: 400,
        padding: '10px 16px',
        
        
    },
    menuIcon: {
        width: '24px',
        height: '24px',
        marginRight: '16px',
    },
    logoutButton: {
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        fontSize: '18px',
        color: '#7d8592',
        cursor: 'pointer',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        padding: '10px 16px', // Ensure padding is consistent with other menu items
        //force height is the same as the others
        maxHeight: '48px',
        //curved edges
        borderRadius: '0.6cm',
    },
    sidebarListItems: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    // Added a wrapper for the list items to control the layout more effectively
    listItemsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '50px', // Adjust gap as needed
    },
    listBox: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        
    }
};

export default styles;